import React from 'react';
import PageTemplate from '../../components/PageTemplate';
const Blockchain = () => {
  return <PageTemplate title="Blockchain Solutions" subtitle="Decentralized Applications" breadcrumb="AI & Data > Blockchain"><div className="content-section"><p>Smart contracts, DeFi solutions, and blockchain development services.</p></div></PageTemplate>;
};
export default Blockchain; 